(function () {
  if (window.__kgHeaderMenuHoverInit) return;
  window.__kgHeaderMenuHoverInit = true;

  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 160;
  var timers = new WeakMap();
  var DESKTOP_QUERY = '(min-width: 990px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function clearTimer(el) {
    var timer = timers.get(el);
    if (timer) {
      clearTimeout(timer);
      timers.delete(el);
    }
  }

  function getTopLevelMenus() {
    return document.querySelectorAll('.header__inline-menu header-menu > details');
  }

  function closeOtherMenus(current) {
    getTopLevelMenus().forEach(function (details) {
      if (details === current) return;
      clearTimer(details);
      details.open = false;
    });
  }

  function openMenu(details) {
    clearTimer(details);
    timers.set(
      details,
      setTimeout(function () {
        if (!isDesktop()) return;
        closeOtherMenus(details);
        if (!details.open) details.open = true;
      }, OPEN_DELAY)
    );
  }

  function closeMenu(details) {
    clearTimer(details);
    timers.set(
      details,
      setTimeout(function () {
        details.open = false;
      }, CLOSE_DELAY)
    );
  }

  function bindHover(details) {
    if (details.getAttribute('data-kg-hover-bound') === 'true') return;
    details.setAttribute('data-kg-hover-bound', 'true');

    details.addEventListener('mouseenter', function () {
      if (isDesktop()) openMenu(details);
    });

    details.addEventListener('mouseleave', function () {
      if (isDesktop()) closeMenu(details);
    });
  }

  function init() {
    getTopLevelMenus().forEach(bindHover);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

(function () {
  if (window.__kgMegaFeatureInit) return;
  window.__kgMegaFeatureInit = true;

  function applyFeature(panel, data) {
    if (!panel || !data) return;

    var imageEl = panel.querySelector('.kg-mega-menu-feature-image');
    var kickerEl = panel.querySelector('.kg-mega-menu-feature-kicker');
    var titleEl = panel.querySelector('.kg-mega-menu-feature-title');

    if (imageEl) {
      if (data.image) {
        imageEl.src = data.image;
        imageEl.alt = data.title || '';
        imageEl.hidden = false;
      } else {
        imageEl.removeAttribute('src');
        imageEl.alt = '';
        imageEl.hidden = true;
      }
    }

    if (kickerEl && typeof data.kicker === 'string') {
      kickerEl.textContent = data.kicker;
      kickerEl.hidden = data.kicker.trim() === '';
    }

    if (titleEl && typeof data.title === 'string') {
      titleEl.textContent = data.title;
      titleEl.hidden = data.title.trim() === '';
    }

    if (data.url) {
      panel.setAttribute('href', data.url);
    }
  }

  function getDefaults(panel) {
    return {
      image: panel.getAttribute('data-default-image') || '',
      kicker: panel.getAttribute('data-default-kicker') || '',
      title: panel.getAttribute('data-default-title') || '',
      url: panel.getAttribute('data-default-url') || '#',
    };
  }

  function bindMegaMenu(details) {
    if (!details) return;

    var panel = details.querySelector('[data-kg-mega-feature]');
    if (!panel) return;

    // Drop prior listeners when re-initing (theme editor section:load).
    if (details.__kgFeatureAbort) {
      details.__kgFeatureAbort.abort();
    }
    details.__kgFeatureAbort = new AbortController();
    var signal = details.__kgFeatureAbort.signal;

    details.setAttribute('data-kg-feature-bound', 'true');
    var defaults = getDefaults(panel);
    var activeZone = null;

    function featureFromZone(zone) {
      return {
        image: zone.getAttribute('data-kg-feature-image') || defaults.image,
        kicker: zone.getAttribute('data-kg-feature-kicker') || defaults.kicker,
        title: zone.getAttribute('data-kg-feature-title') || defaults.title,
        url: zone.getAttribute('data-kg-feature-url') || defaults.url,
      };
    }

    // mouseover + closest handles nested zones reliably when moving item → item.
    // mouseenter on each zone often skips updates while the pointer stays inside a parent zone.
    details.addEventListener(
      'mouseover',
      function (event) {
        var zone = event.target.closest('[data-kg-feature-zone]');
        if (!zone || !details.contains(zone)) return;
        if (zone === activeZone) return;
        activeZone = zone;
        applyFeature(panel, featureFromZone(zone));
      },
      { signal: signal }
    );

    details.addEventListener(
      'toggle',
      function () {
        if (!details.open) {
          activeZone = null;
          applyFeature(panel, defaults);
        }
      },
      { signal: signal }
    );
  }

  function initMegaFeature() {
    document.querySelectorAll('details.kg-mega-menu').forEach(bindMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaFeature);
  } else {
    initMegaFeature();
  }

  document.addEventListener('shopify:section:load', initMegaFeature);
})();

(function () {
  if (window.__kgFaqInit) return;
  window.__kgFaqInit = true;

  var DURATION = 350;

  function getPanel(details) {
    return details.querySelector('.kg-faq-answer');
  }

  function openItem(details, animate) {
    var panel = getPanel(details);
    details.open = true;

    if (!panel) return;

    if (!animate) {
      panel.style.height = 'auto';
      return;
    }

    panel.style.overflow = 'hidden';
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.transition = 'height ' + DURATION + 'ms ease';
    panel.style.height = panel.scrollHeight + 'px';

    function onEnd(event) {
      if (event.propertyName !== 'height') return;
      panel.style.height = 'auto';
      panel.style.overflow = '';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', onEnd);
    }

    panel.addEventListener('transitionend', onEnd);
  }

  function closeItem(details, animate) {
    var panel = getPanel(details);

    if (!panel) {
      details.open = false;
      return;
    }

    if (!animate) {
      details.open = false;
      panel.style.height = '';
      panel.style.overflow = '';
      panel.style.transition = '';
      return;
    }

    panel.style.height = panel.scrollHeight + 'px';
    panel.style.overflow = 'hidden';
    panel.offsetHeight;
    panel.style.transition = 'height ' + DURATION + 'ms ease';
    panel.style.height = '0px';

    function onEnd(event) {
      if (event.propertyName !== 'height') return;
      details.open = false;
      panel.style.height = '';
      panel.style.overflow = '';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', onEnd);
    }

    panel.addEventListener('transitionend', onEnd);
  }

  function bindFaqSection(sectionEl) {
    if (!sectionEl || sectionEl.getAttribute('data-kg-faq-bound') === 'true') return;
    sectionEl.setAttribute('data-kg-faq-bound', 'true');

    var oneOpen = sectionEl.getAttribute('data-kg-faq-one-open') !== 'false';
    var list = sectionEl.querySelector('.kg-faq-list');
    if (!list) return;

    var items = list.querySelectorAll('details.kg-faq-item');
    var openItems = list.querySelectorAll('details.kg-faq-item[open]');

    if (!openItems.length && items.length) {
      openItem(items[0], false);
    } else {
      openItems.forEach(function (item) {
        var panel = getPanel(item);
        if (panel) panel.style.height = 'auto';
      });
    }

    items.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary || summary.getAttribute('data-kg-faq-summary-bound') === 'true') return;
      summary.setAttribute('data-kg-faq-summary-bound', 'true');

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (details.open) {
          closeItem(details, true);
          return;
        }

        if (oneOpen) {
          list.querySelectorAll('details.kg-faq-item[open]').forEach(function (item) {
            if (item !== details) closeItem(item, true);
          });
        }

        openItem(details, true);
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('section.kg-faq').forEach(function (sectionEl) {
      sectionEl.removeAttribute('data-kg-faq-bound');
      bindFaqSection(sectionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }

  document.addEventListener('shopify:section:load', initFaq);
})();




document.querySelectorAll('.kg-scroll-link').forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();


    const scrollId = link.getAttribute('href')?.replace('#', '');
    const target = document.querySelector(`[data-scroll-id="${scrollId}"]`);


    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });


      history.pushState(null, '', `#${scrollId}`);
    }
  });
});